import { css } from 'linaria';

export const calculatorQuantityWrapper = css`
  width: 100%;
  margin-bottom: var(--space-200);
  background-color: var(--secondary-green-light);
  border-radius: var(--space-50);
  box-sizing: border-box;
  padding: var(--space-100);
  display: flex;
  gap: var(--space-100);
  cursor: pointer;
  transition: 0.3s;
  &:hover {
    background-color: var(--secondary-green-primary);
  }
`;

export const calculationQuantityTypography = css`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
`;

export const calculationChevronWrapper = css`
  display: flex;
  align-self: center;
  margin-left: auto;
`;
